const WEB_SESSION_STORAGE_KEY = 'inhound:web-session';

interface StoredWebSession {
  accessToken: string;
}

export function readStoredWebSession(): StoredWebSession | null {
  if (typeof window === 'undefined') return null;

  try {
    const rawValue = window.localStorage.getItem(WEB_SESSION_STORAGE_KEY);
    if (!rawValue) return null;

    const parsed = JSON.parse(rawValue) as Partial<StoredWebSession>;
    if (!parsed.accessToken || typeof parsed.accessToken !== 'string') {
      return null;
    }

    return { accessToken: parsed.accessToken };
  } catch {
    return null;
  }
}

export function writeStoredWebSession(session: StoredWebSession) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(WEB_SESSION_STORAGE_KEY, JSON.stringify(session));
}

export function clearStoredWebSession() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(WEB_SESSION_STORAGE_KEY);
}
